{
  "nl": {
    "upsell": {
      "categories": {
        "category": "Categorie",
        "home_automation": "Domotica",
        "integration": "Integratie",
        "interior_decoration": "Interieurdecoratie",
        "interior_doors": "Binnendeuren",
        "kitchen": "Keuken",
        "marketing": "Marketing",
        "real_estate_agent": "Makelaar",
        "telecom": "Telecom",
        "wood_finishing": "Houtafwerking"
      },
      "contact_us": "Geïnteresseerd? Neem contact op!",
      "decisions_partners": {
        "guidance": "Beslissingspartners kunnen voorstellen maken en/of beheren als ze daarvoor toestemming hebben gekregen.",
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de functie Beslissingspartners. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}"
      },
      "decisions_proposals_multiple_approval": {
        "cta": "Chat met ons voor meer informatie",
        "description": "Ben je het beu om een voorstel af te keuren om enkele wijzigingen toe te voegen en helemaal opnieuw te beginnen? Meerdere goedkeuringen nodig hebben zou je niet moeten vertragen.",
        "description_2": "Laat je klanten meerdere voorstellen goedkeuren in dezelfde beslissing. Je hoeft een bestaand voorstel niet goed te keuren of een nieuwe beslissing te starten.",
        "description_3": "Minder gedoe en meer tijd om je te richten op wat echt belangrijk is: je klant!",
        "intercom": "Hallo Ziggu! Ik wil dat de klant meerdere voorstellen kan goedkeuren binnen een beslissing. Kun je wat meer informatie geven? Met vriendelijke groet, %{name}",
        "premium_add_on": "Premium uitbreiding",
        "title": "Bespaar tijd met de flexibele voorstellen add-on!"
      },
      "decisions_reminders": {
        "guidance": "Met herinneringen kunt u klanten automatisch laten weten dat er voorstellen wachten op een beslissing.",
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de functie Herinneringen. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}"
      },
      "financials": {
        "guidance": "Maak betalingsschijven aan op basis van goedgekeurde voorstellen en deel ze met je klanten via het klantenportaal.<br>Houd je financiële communicatie transparant en professioneel, klanten hebben altijd een duidelijk overzicht van wat er verschuldigd is en wanneer.",
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de Financiën-functie voor termijnen bij beslissingen. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}"
      },
      "imInterested": "Ik heb interesse!",
      "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in {upsell}. Kunt u wat meer informatie geven? Met vriendelijke groeten, %{name}",
      "interestedToBeListed": "Geïnteresseerd om hier vermeld te worden",
      "lookingfor": "Waar ben je naar op zoek? Bv. 3D visualisatie, keukens, telecom, ...",
      "multilingual": {
        "ai_included": "AI-vertaling inbegrepen: met één klik vul je de ontbrekende talen in.",
        "announcements_body": "Je kan nieuwsberichten al naar {languages} vertalen. Overal elders schrijf je met de multilingual feature één keer en leest elke klant het in de taal die die zelf instelde.",
        "bar_covered": "Je publiceert al in het {language}",
        "bar_uncovered": "Je publiceert nog niet in het {language}",
        "body": "Vandaag krijgen ze allemaal dezelfde versie. Met de multilingual feature krijgt elke klant deze inhoud in de taal die die zelf instelde.",
        "chip_tooltip": "{customers} klant heeft {language} als taal | {customers} klanten hebben {language} als taal",
        "cta": "Vraag meer info",
        "cta_expand": "Bekijk details",
        "cta_sent": "We nemen contact op",
        "customers_count": "1 klant | {count} klanten",
        "error_intercom": "We konden je vraag niet versturen. Probeer het opnieuw.",
        "headline": "Je {count} klant {scope} spreekt {languages} | Je {count} klanten {scope} spreken {languages}",
        "headline_single": "Je {count} klant {scope} spreekt {language}. | Alle {count} klanten {scope} spreken {language}.",
        "intercom": "Ik wil meer weten over de multilingual feature",
        "languages_count": "1 taal | {count} talen",
        "languages_other_count": "1 andere taal | {count} andere talen",
        "missing_add": "Toevoegen",
        "missing_added": "{language} staat nu in je bedrijfstalen",
        "missing_hint": "Wat je toevoegt wordt overal beschikbaar als vertaaltaal, voor je hele bedrijf.",
        "missing_hint_announcements_only": "Wat je toevoegt wordt een vertaaltaal voor je hele bedrijf. Vandaag gebruik je die in nieuwsberichten; met de multilingual feature ook overal elders.",
        "missing_no_permission": "Bedrijfstalen toevoegen vereist de rol Eigenaar.",
        "missing_settings_link": "Alle talen beheren in bedrijfsinstellingen",
        "missing_title": "{count} klant {scope} spreekt {languages} | {count} klanten {scope} spreken {languages}",
        "plan": "Enterprise",
        "scope_project": "in dit project",
        "scope_selection": "in deze selectie"
      },
      "not_included": "Geïnteresseerd in deze functionaliteit?",
      "project_email_forwarding": {
        "cta": "E-mails doorsturen naar {project_name}",
        "description": "Laat iedereen binnen je team e-mails rechtstreeks doorsturen naar je Ziggu-projecten.",
        "intercom": "Hallo Ziggu! Ik wil graag e-mails doorsturen naar projecten. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}",
        "marketplace": {
          "title": "Project email forwarding",
          "title_sub": "E-mails rechtstreeks doorsturen naar je Ziggu-projecten."
        },
        "title": "Nieuw! E-mails doorsturen naar projecten",
        "youtube_id": "vLQtH9GzAXc"
      },
      "project_experience": {
        "contactme": "Je mag mij contacteren hierover!",
        "cta": "Op zoek naar een betere projectervaring?",
        "description": "Gepersonaliseerde project-URL en inlogscherm <br/> Eigen projectomgeving wanneer ingelogd <br/> Project branded e-mails <br/> Maakt projectsamenwerking met andere vastgoedontwikkelaars eenvoudiger",
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de Project Experience-module. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}",
        "marketplace": {
          "title": "Project experience",
          "title_sub": "Verbeter uw projectbranding met een gepersonaliseerde project-URL en -omgeving"
        },
        "title": "Laat jouw klanten zich thuis voelen met de gloednieuwe Project Experience!",
        "youtube_id": "f26cNo2rwWE"
      },
      "project_templates": {
        "cta": "Importeer een sjabloon?",
        "cta2": "Deze sjabloon importeren in uw projecten? Klik hier om deze functie te ontgrendelen!",
        "description": "<p>Transformeer hoe je projecten beheert met vooraf gebouwde sjablonen die je tijd besparen en je team op één lijn houden.</p><br>\n<p><strong>Voordelen van sjablonen:</strong></p>\n<ul>\n    <li><strong>- Bespaar uren</strong> op repetitieve taken—importeer volledige projectstructuren in seconden.</li>\n    <li><strong>- Verbeterde standaardisatie</strong> door alles op één plek te hebben, van taken tot documenten.</li>\n    <li><strong>- Verhoog de efficiëntie</strong> door routinetaken te automatiseren, zodat je je kunt richten op wat het meest belangrijk is.</li>\n</ul>\n<br/><strong>Upgrade vandaag nog en krijg meer gedaan met minder moeite!</strong>",
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de sjablonen functionaliteit, kan je mij wat meer informatie geven hierover? Groeten, %{name}",
        "marketplace": {
          "title": "Sjablonen",
          "title_sub": "Transformeer hoe je projecten beheert met vooraf gebouwde sjablonen die je tijd besparen en je team op één lijn houden."
        },
        "title": "Werk slimmer met sjablonen!"
      },
      "proposal_choice_lists": {
        "guidance": "Met keuzelijsten kunt u klanten keuzes laten maken in voorstellen.",
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de functie Keuzelijsten. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}"
      },
      "signatures": {
        "cta_text": "Handtekeningen nodig voor uw documenten? Neem contact op",
        "guidance": "Met handtekeningen kunt u klanten belangrijke documenten digitaal laten ondertekenen.",
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in de functie Handtekeningen. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}"
      },
      "workflows": {
        "attach_body": "Tip: ook beslissingen en enquêtes kunnen aan een fase hangen. Ze worden dan vanzelf gepubliceerd zodra de fase bereikt wordt.",
        "cta": "Meer weten",
        "cta_sent": "We nemen contact op",
        "dismiss": "Nu niet",
        "intercom": "Ik wil meer weten over wat workflows toevoegen aan fases.",
        "move_hint_phases": "Tip: een fase kan zelf beslissingen, enquêtes en taken publiceren zodra ze bereikt wordt.",
        "move_hint_tasks": "Tip: een fase kan ook zelf beslissingen en enquêtes publiceren zodra ze bereikt wordt."
      },
      "workflows_elements": {
        "guidance": "Je huidige pakket bevat dit type element niet. Het blijft op de fase staan, maar klanten ontvangen het pas na een upgrade.",
        "intercom": "Hallo Ziggu! Ik ben geïnteresseerd in het delen van beslissingen, enquêtes en taken via fases. Kan je wat meer informatie geven? Met vriendelijke groet, %{name}"
      }
    }
  }
}
